import React from 'react'
import { countryMeta } from './helpers'

export function Lozenge({ c, bg, children, sm }: { c: string; bg: string; children: React.ReactNode; sm?: boolean }) {
  return (
    <span
      className={`inline-flex items-center rounded font-medium whitespace-nowrap tracking-[0.01em] ${
        sm ? 'px-1.5 py-px text-[10px]' : 'px-2 py-0.5 text-[11px]'
      }`}
      style={{ color: c, background: bg }}
    >
      {children}
    </span>
  )
}

export function Dot({ c, size = 6 }: { c: string; size?: number }) {
  return (
    <span
      className="inline-block shrink-0 rounded-full"
      style={{ width: size, height: size, background: c }}
    />
  )
}

export function SmallTag({ children }: { children: React.ReactNode }) {
  return (
    <span className="inline-block text-[11px] px-[7px] py-px rounded bg-an-surface-3 text-an-ink-3 font-[450] whitespace-nowrap">
      {children}
    </span>
  )
}

export function CountryChip({ code, sm }: { code: string | null; sm?: boolean }) {
  const m = countryMeta(code)
  return (
    <span
      className={`inline-flex items-center gap-1 rounded bg-an-surface-3 text-an-ink-2 font-medium whitespace-nowrap ${
        sm ? 'text-[10px] px-1.5 py-px' : 'text-[11px] px-[7px] py-0.5'
      }`}
    >
      {m.flag && <span className={sm ? 'text-[11px]' : 'text-xs'}>{m.flag}</span>}
      {m.label}
    </span>
  )
}
